export function croquis() {
    const body = document.getElementById('app');
    const canvas = document.getElementById("sig-canvas");
    const contexto = canvas.getContext("2d");
    const color = "black";
    const grosor = 2;
    let xAnterior = 0, yAnterior = 0, xActual = 0, yActual = 0;
    const obtenerXReal = (clientX) => clientX - canvas.getBoundingClientRect().left;
    const obtenerYReal = (clientY) => clientY - canvas.getBoundingClientRect().top;
    let comienzo = false;
    canvas.addEventListener("pointerdown", event => {
        event.preventDefault();
        const onMove = event => moverPincel(event);
        const onUp = () => {
            canvas.removeEventListener('pointermove', onMove);
            canvas.removeEventListener('pointerup', onUp);
        };
        canvas.addEventListener('pointermove', onMove);
        canvas.addEventListener('pointerup', onUp);
        pintar(event);
    });
    canvas.addEventListener("touchstart", event => {
        event.preventDefault();
    });
    const pintar = (event) => {
        xAnterior = xActual;
        yAnterior = yActual;
        xActual = obtenerXReal(event.clientX);
        yActual = obtenerYReal(event.clientY);
        contexto.beginPath();
        contexto.fillStyle = color;
        contexto.fillRect(xActual, yActual, grosor, grosor);
        contexto.closePath();
        comienzo = true;
    };
    const moverPincel = (event) => {
        if (!comienzo) {
            return;
        }
        xAnterior = xActual;
        yAnterior = yActual;
        xActual = obtenerXReal(event.clientX);
        yActual = obtenerYReal(event.clientY);
        contexto.beginPath();
        contexto.moveTo(xAnterior, yAnterior);
        contexto.lineTo(xActual, yActual);
        contexto.strokeStyle = color;
        contexto.lineWidth = grosor;
        contexto.stroke();
        contexto.closePath();
    };
}
export function clearCanvas() {
    const canvas = document.getElementById("sig-canvas");
    const contexto = canvas.getContext("2d");
    contexto.clearRect(0, 0, canvas.width, canvas.height);
}
export function saveCanvas() {
    const canvas = document.getElementById("sig-canvas");
    return canvas.toDataURL();
}
